<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> AJUSTE DO ESTOQUE </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-toolbar-title v-if="setting.id"
          >{{ setting.id }} - {{ setting.name }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn outlined color="grey darken-3" @click="goToBackList()">
          <v-icon left>mdi-chevron-left</v-icon> Voltar
        </v-btn>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="12" md="4">
              <v-text-field
                v-model="setting.name"
                class="text-field-uppercase"
                label="Descrição"
                dense
                outlined
                required
                hide-details
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="8"> </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" md="2">
              <v-select
                :items="yesOrNot"
                v-model="setting.validation"
                label="Requer Validação"
                required
                dense
                outlined
                hide-details
                :rules="[rules.required]"
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" md="10">
              <label>
                A atualização do estoque requer validação do franqueador
              </label>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" md="2">
              <v-select
                :items="typesOperation"
                v-model="setting.type"
                label="Tipo de operação"
                required
                dense
                outlined
                hide-details
                :rules="[rules.required]"
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" md="10"></v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" md="6" class="py-0">
              <v-checkbox
                v-model="setting.price"
                label="Preços nos itens"
                hide-details
              >
              </v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" md="6" class="py-0">
              <v-checkbox
                v-model="setting.estimate"
                label="Estimativa de produção"
                hide-details
              >
              </v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" md="6" class="py-0">
              <v-checkbox
                v-model="setting.grid"
                label="Utiliza grade aberta"
                hide-details
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn color="blue darken-3" dark class="mt-5" @click="validate">
                <v-icon left>mdi-send</v-icon> Salvar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
  </div>
</template>

<script>
import { URL } from "@/api/config";
export default {
  components: {},
  data: () => ({
    loading: false,
    setting: {
      id: "",
      name: "",
      type: "E",
      info: false,
      price: false,
      estimate: false,
      grid: false,
      validation: false,
    },
    settings: [
      {
        id: 1,
        name: "ESTOQUE INICIAL (GRADE PADRÃO)",
        type: "E",
        validation: "S",
        info: false,
        price: false,
        estimate: true,
        grid: false,
      },
      {
        id: 3,
        name: "ENTRADA (GRADE ABERTA)",
        type: "E",
        validation: "S",
        info: false,
        price: false,
        estimate: false,
        grid: true,
      },
      {
        id: 4,
        name: "SAÍDA (GRADE ABERTA)",
        type: "S",
        validation: "N",
        info: false,
        price: false,
        estimate: false,
        grid: true,
      },
      {
        id: 5,
        name: "ENTRADA (GRADE FECHADA)",
        type: "E",
        validation: "N",
        info: false,
        price: false,
        estimate: false,
        grid: false,
      },
      {
        id: 6,
        name: "SAÍDA (GRADE FECHADA)",
        type: "S",
        validation: "N",
        info: false,
        price: false,
        estimate: false,
        grid: false,
      },
      {
        id: 7,
        name: "ESTOQUE INICIAL (GRADE ABERTA)",
        type: "E",
        validation: "N",
        info: false,
        price: false,
        estimate: true,
        grid: true,
      },
    ],
    yesOrNot: [
      { value: "S", text: "Sim" },
      { value: "N", text: "Não" },
    ],
    typesOperation: [
      { value: "E", text: "(+) Entrada" },
      { value: "S", text: "(-) Saída" },
    ],
    valid: true,
    lazy: false,
    rules: {
      required: (value) => !!value || "Campo Obrigatorio",
    },
  }),
  computed: {},
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      if (this.$route.params.id) {
        this.setting = this.settings.find(
          (item) => item.id == this.$route.params.id
        );
        // this.getSetting(this.$route.params.id);
      }
    },
    async getSetting(id) {
      // this.showLoading();
      this.loading = true;
      try {
        let response = await fetch(`${URL}express/setting/${id}`);
        this.cest = await response.json();
      } catch (error) {
        this.cest = {};
        console.log(error);
        //this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    goToBackList() {
      this.$router.push({ name: "SettingsOrderExpress" });
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.setting.name = this.setting.name.toUpperCase();
        let data = this.setting;
        console.log(data);
        // if (this.setting.id === "") {
        //   this.post(data);
        // } else {
        //   this.update(this.setting.id, data);
        // }
      }
    },
    async post(data) {
      // this.showLoading();
      this.loading = true;
      let myHeaders = new Headers({
        "Content-Type": "application/json",
      });
      try {
        let res = await fetch(`${URL}express/setting`, {
          headers: myHeaders,
          method: "POST",
          body: data,
        });
        if (res) {
          // this.showAlert({
          //   message: "Tipo de Fornecedor salvo com sucesso",
          //   type: "success",
          // });
          this.goToBackList();
        }
      } catch (error) {
        console.log(error);
        // this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    async update(id, data) {
      this.loading = true;
      let myHeaders = new Headers({
        "Content-Type": "application/json",
      });
      try {
        let res = await fetch(`${URL}express/setting/${id}`, {
          headers: myHeaders,
          method: "PUT",
          body: data,
        });
        if (res) {
          // this.showAlert({
          //   message: "Tipo de Fornecedor atualizado com sucesso",
          //   type: "success",
          // });
          this.goToBackList();
        }
      } catch (error) {
        console.log(error);
        // this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    getLabelStatus(status) {
      return status == 1 ? "Ativo" : "Desativado";
    },
  },
};
</script>
<style>
.text-field-uppercase input,
.text-field-uppercase textarea {
  text-transform: uppercase;
}
</style>
